module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.e65ae7ed.ttf";